import React, {useState, useEffect} from 'react';
import './App.css';
import TowerMap from './components/TowerMap';
import RotationList from './components/RotationList';
import {useRotationOrder, TOWERS, TOWERS_ARRAY} from './hooks/useRotationOrder';

const STORAGE_KEY = 'bpt_tower_types';

function App() {
  const [towerTypes, setTowerTypes] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : {};
    } catch {
      return {};
    }
  });

  const [showOrder, setShowOrder] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(towerTypes));
  }, [towerTypes]);

  const rotationOrder = useRotationOrder(towerTypes);
  const allConfigured = TOWERS.every((t) => towerTypes[t.id]);

  const handleReset = () => {
    setTowerTypes({});
  };

  const handleRandom = () => {
    const towers = {};

    for (let i = 1; i < 7; i++) {
      towers[i] = shuffleArray(TOWERS_ARRAY)
    }

    setTowerTypes(towers);
  };

  function shuffleArray(arr) {
    let currentIndex = arr.length;

    // Enquanto houver elementos para embaralhar...
    while (currentIndex !== 0) {

      // Escolhe um elemento restante (do final até o início)
      let randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // Troca o elemento atual com o elemento escolhido aleatoriamente
      [arr[currentIndex], arr[randomIndex]] = [
        arr[randomIndex], arr[currentIndex]];
    }

    return arr[0];
  }

  return (
    <div className="app-bg">
      <header className="app-header">
        <div className="header-title">
          <span className="header-icon">🏰</span>
          <div>
            <h1>Bless Castle</h1>
            <p className="header-sub">Organizador de Torres — Priston Tale</p>
          </div>
        </div>
        <button className="reset-btn" onClick={()=>setShowOrder((prev) => !prev)} title="Randomizar as torres">
          🔀 {showOrder ? 'Ver Rotação' : 'Ocultar rotação'}
        </button>
        <button className="reset-btn" onClick={handleRandom} title="Randomizar as torres">
          🔀 Aleatório
        </button>
        <button className="reset-btn" onClick={handleReset} title="Resetar todas as torres">
          🔄 Resetar
        </button>
      </header>

      <main className="app-main">
        <section className="map-section">
          <h2 className="section-title">🗺️ Mapa do Castelo</h2>
          <p className="section-sub">Selecione o tipo de cada torre abaixo</p>
          <TowerMap
            towerTypes={towerTypes}
            onChange={setTowerTypes}
            rotationOrder={rotationOrder}
          />
          <div className="legend">
            <span className="legend-item neutral">🗿 Neutra</span>
            <span className="legend-item fire">🔥 Fogo</span>
            <span className="legend-item lightning">⚡ Raio</span>
            <span className="legend-item ice">❄️ Gelo</span>
          </div>
        </section>

        <aside className="side-section">
          <RotationList rotationOrder={rotationOrder} towerTypes={towerTypes} showOrder={showOrder}/>

          {allConfigured && (
            <div className="priority-info">
              <h4>Prioridade de Derrubada</h4>
              <div className="priority-steps">
                <span className="p-step neutral">1º Neutra</span>
                <span className="arrow">→</span>
                <span className="p-step fire">2º Fogo</span>
                <span className="arrow">→</span>
                <span className="p-step lightning">3º Raio</span>
                <span className="arrow">→</span>
                <span className="p-step ice">4º Gelo</span>
              </div>
            </div>
          )}
        </aside>
      </main>

      <footer className="app-footer">
        <p>Torres BPT · Bless Castle Rotation Manager · {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}

export default App;
